import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1ed4f473"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "app-footer_box"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-body_box"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "record-information_box"
}, " ©COPYRIGHT 2020 中远方舟网络科技有限公司 闽ICP备16005372号-1 ", -1));

const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
}